export const Overline = ({ children, className = "" }) => (
  <p className={`flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-gold ${className}`}>
    <span className="h-px w-8 bg-brand-gold/60" aria-hidden="true" />
    {children}
  </p>
);

export const SectionHeading = ({ overline, title, text, align = "left" }) => {
  const centered = align === "center";
  return (
    <div className={`max-w-2xl ${centered ? "mx-auto text-center" : ""}`}>
      {overline && <Overline className={centered ? "justify-center" : ""}>{overline}</Overline>}
      <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.1] tracking-tight text-brand-charcoal sm:text-5xl lg:text-6xl text-balance">
        {title}
      </h2>
      {text && <p className="mt-5 text-base leading-relaxed text-brand-stone">{text}</p>}
    </div>
  );
};
